export abstract class AbstractSerializer<T = void> {
    constructor(..._args: any[]) {}
    public abstract read(...args: unknown[]): Promise<T>;
}
